module.exports = __webpack_public_path__ + "img/manstrike-image.38eb2a16.png";